import { Box, ProgressBar, Text } from '@factorialco/deprecated-design-system'

import { Statuses } from 'modules/processes/domain'

type Props = {
  totalItems: number
  completedItems: number
  status: Statuses
}

export const ItemProgress = ({ completedItems, totalItems, status }: Props) => {
  const isFinalized = status === Statuses.Finalized

  const label = `${completedItems}/${totalItems}`

  return (
    <Box flexDirection="row" alignItems="center">
      <Box width="full">
        <ProgressBar
          amount={completedItems}
          total={totalItems}
          progressColor="viridian1000"
          {...(isFinalized && { progressColor: 'viridian400', barColor: 'viridian200' })}
        />
      </Box>

      <Box paddingLeft="s8">
        <Text.Normal size="200" weight="medium" color={isFinalized ? 'grey600' : undefined}>
          {label}
        </Text.Normal>
      </Box>
    </Box>
  )
}
